var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.6037 21.1467C35.2418 21.5366 35.2418 22.4634 34.6037 22.8533L1.52145 43.0702C0.855097 43.4774 1.85836e-06 42.9979 1.89389e-06 42.2169L3.73357e-06 1.78306C3.7691e-06 1.00213 0.855099 0.522558 1.52145 0.929774L34.6037 21.1467Z","fill":"white"}));
}

Play.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 36 44","fill":"none"};

module.exports = Play;

Play.default = Play;
